define("shared/components/shared/wizard/next-button", ["exports", "@ember/component", "@ember/object", "@ember/runloop", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _runloop, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#unless @isLastSlide}}
    {{#if (has-block)}}
      <Shared::Ui::Button
        @isDisabled={{or @isDisabled this._isDisabled}}
        @onClick={{action "nextSlide"}}
        @variant="none"
        class={{if @buttonClass @buttonClass this.defaultClass}}
        data-test-id="next button"
        data-test-id-option={{@dataTestIdOption}}
        ...attributes
      >
        {{yield}}
      </Shared::Ui::Button>
    {{else}}
      <Shared::Ui::Button
        @isDisabled={{or @isDisabled this._isDisabled}}
        @onClick={{action "nextSlide"}}
        @text={{this.buttonText}}
        @variant="none"
        class={{if @buttonClass @buttonClass this.defaultClass}}
        data-test-id="next button"
        data-test-id-option={{@dataTestIdOption}}
        ...attributes
      />
    {{/if}}
  {{/unless}}
  */
  {
    "id": "OCLbcuYL",
    "block": "[[[41,[51,[30,1]],[[[41,[48,[30,6]],[[[1,\"    \"],[8,[39,3],[[16,0,[52,[30,2],[30,2],[30,0,[\"defaultClass\"]]]],[24,\"data-test-id\",\"next button\"],[16,\"data-test-id-option\",[30,3]],[17,4]],[[\"@isDisabled\",\"@onClick\",\"@variant\"],[[28,[37,4],[[30,5],[30,0,[\"_isDisabled\"]]],null],[28,[37,5],[[30,0],\"nextSlide\"],null],\"none\"]],[[\"default\"],[[[[1,\"\\n      \"],[18,6,null],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,3],[[16,0,[52,[30,2],[30,2],[30,0,[\"defaultClass\"]]]],[24,\"data-test-id\",\"next button\"],[16,\"data-test-id-option\",[30,3]],[17,4]],[[\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[28,[37,4],[[30,5],[30,0,[\"_isDisabled\"]]],null],[28,[37,5],[[30,0],\"nextSlide\"],null],[30,0,[\"buttonText\"]],\"none\"]],null],[1,\"\\n\"]],[]]]],[]],null]],[\"@isLastSlide\",\"@buttonClass\",\"@dataTestIdOption\",\"&attrs\",\"@isDisabled\",\"&default\"],false,[\"unless\",\"if\",\"has-block\",\"shared/ui/button\",\"or\",\"action\",\"yield\"]]",
    "moduleName": "shared/components/shared/wizard/next-button.hbs",
    "isStrictMode": false
  });
  let NextButtonComponent = _exports.default = (_class = class NextButtonComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _defineProperty(this, "defaultClass", 'o--btn o--btn--primary u--float--right u--p__lr__lg qa--slide_next');
      _initializerDefineProperty(this, "_isDisabled", _descriptor2, this);
    }
    get defaultButtonText() {
      return this.intl.t('shared_words.next');
    }
    get buttonText() {
      return this.args.text ? this.args.text : this.defaultButtonText;
    }
    nextSlide() {
      this.args.onClick?.();
      if (this.args.delay) {
        (0, _runloop.later)(() => {
          this.args.nextSlide();
        }, this.args.delay);
      } else {
        this.args.nextSlide();
      }
      if (this.args.shouldPreventDblClicks) {
        this._isDisabled = true;
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_isDisabled", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "nextSlide", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "nextSlide"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NextButtonComponent);
});